import React from 'react';
import { Map, Marker, TileLayer } from 'react-leaflet'
import './index.css';

class Maps extends React.Component {
    constructor() {
        super()
        this.state = {
          lat: 51.505,
          lng: -0.09,
          zoom: 13
        }
      }
    render (){
        let lat = this.props.enterLat ? this.props.enterLat : this.state.lat;
        let lng = this.props.enterLng ? this.props.enterLng : this.state.lng;
        const position = [lat, lng];
            return (
                <Map center={position} zoom={this.state.zoom} className="leaflet-map" dragging='false' tap='false'>
                    <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url='http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png'
                    />
                        <Marker position={position}>
                    </Marker>
                </Map>
        );
    }
}

export default Maps;
